import React, { useState } from "react";
import axios from "../../../../../Global/axios";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";

const AuthorizeVisaForm = ({
  openAutherizedForm,
  setOpenAutherizedForm,
  setUpdateVrfData,
}) => {
  const [sumbmitLoading, setSubmitLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [file, setFile] = useState()
  const [fileError,setFIleError] = useState("")
 
  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      file?.type != "image/png" &&
      file?.type != "image/jpg" &&
      file?.type != "application/pdf" &&
      file?.type != "image/jpeg"
    ) {
      setFIleError("The file must be a file of type: png, jpg, jpeg, pdf.");
      return;
    } else {
      setFIleError("");
    }
      
    setSubmitLoading(true);
    const VrfId = openAutherizedForm.vrfId.toUpperCase();
    const visa_number = e.target.visa_number.value.toUpperCase();
    const visa_date = String(e.target.visa_date.value.toUpperCase())
      .split("-")
      .reverse()
      .join("-");
    const visa_expiry_date = String(
      e.target.visa_expiry_date.value.toUpperCase()
    )
      .split("-")
      .reverse()
      .join("-");
    const formData = new FormData();
    formData.append("status", "authorize");
    formData.append("visa_number", visa_number);
    formData.append("visa_date", visa_date);
    formData.append("visa_expiry_date", visa_expiry_date);
    formData.append("file", file);
    
    if (visa_number != "" && visa_date != "" && visa_expiry_date != "") {
      try {
        const response = await axios.post(
          `/dashboard/gr-visa-vrf/status-update/${VrfId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setSubmitLoading(false);
          dispatch(
            setAppError({ msg: response.data.message, color: "bg-green-600" })
          );
          setOpenAutherizedForm({ open: false, vrfId: "" });
          setUpdateVrfData((prev) => !prev);
        }
      } catch (e) {
        setSubmitLoading(false);
        dispatch(setAppError({ msg: e.response.data.message }));
      }
    }
  };
  return (
    <form
      onSubmit={submitHandler}
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 uppercase  justify-center items-center ${
        openAutherizedForm ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-2xl w-full h-auto  min-h-[14rem] rounded-md bg-white/90 flex justify-center items-center flex-col">
        <h2 className="text-2xl p-4 pb-1 text-center">VISA Authorise</h2>

        <div className="mt-8 mb-4">
          <label className="block mb-2 font-medium" htmlFor="">
            VISA Number
          </label>
          <input
            type="number"
            name="visa_number"
            className="input input-sm uppercase w-56"
            placeholder="Enter Visa Number"
            required
          />
        </div>
        <div className="mb-8">
          <label className="block mb-2 font-medium" htmlFor="">
            Visa Date
          </label>
          <input
            type="date"
            name="visa_date"
            placeholder="Enter expiry date"
            className="input uppercase input-sm w-56"
            required
          />
        </div>
        <div className="mb-8">
          <label className="block mb-2 font-medium" htmlFor="">
            VISA Expiry Date
          </label>
          <input
            type="date"
            name="visa_expiry_date"
            placeholder="Enter expiry date"
            className="input uppercase input-sm w-56"
            required
          />
        </div>
        <div className="">
          <label className="block mb-2 font-medium" htmlFor="">
            select file
          </label>
          <input
            type="file"
            accept="image/png, image/jpg, image/jpg application/pdf"
            name="file"
            placeholder="select file"
            className="input uppercase w-56"
            required
            onChange={(e) => {
              setFile(e.target.files[0]);
              setFIleError("")
            }}
          />
        </div>
        {fileError != "" && <p className="bg-rose-100 px-1 my-2 text-red">{fileError}</p>}

        <div className="flex gap-3 min-w-fit mt-8 mx-5 mb-5">
          <button
            className="p-1 w-20 uppercase rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenAutherizedForm(false);
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="p-1 w-fit rounded-md uppercase ring-1 ring-red text-white bg-red"
          >
            {sumbmitLoading ? "Submiting.." : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default AuthorizeVisaForm;
